export default class DragHandler {
  static dragMoveListener(event) {
    const { target } = event;
    // keep the dragged position in the data-x/data-y attributes
    const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
    const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    // translate the element
    target.style.webkitTransform = `translate(${x}px, ${y}px)`;
    target.style.transform = `translate(${x}px, ${y}px)`;

    // update the posiion attributes
    target.setAttribute('data-x', x);
    target.setAttribute('data-y', y);
  }

  static dragEndListener() {
  }

  // static resizeListener(event) {
  //   const { target } = event;
  //   let x = (parseFloat(target.getAttribute('data-x')) || 0);
  //   let y = (parseFloat(target.getAttribute('data-y')) || 0);

  //   // update the element's style
  //   target.style.width = `${event.rect.width}px`;
  //   target.style.height = `${event.rect.height}px`;

  //   // translate when resizing from top or left edges
  //   x += event.deltaRect.left;
  //   y += event.deltaRect.top;

  //   target.style.webkitTransform = `translate(${x}px,${y}px)`;
  //   target.style.transform = `translate(${x}px,${y}px)`;

  //   target.setAttribute('data-x', x);
  //   target.setAttribute('data-y', y);
  //   // target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height);
  // }

  static initDraggable(draggableSelector) {
    window.interact(draggableSelector)
      .draggable({
        restrict: {
          restriction: 'parent',
          endOnly: true,
          elementRect: {
            top: 0,
            left: 0,
            bottom: 1,
            right: 1,
          },
        },
        onmove: DragHandler.dragMoveListener,
        onend: DragHandler.dragEndListener,
      });
    // .resizable({
    //   // resize from all edges and corners
    //   edges: {
    //     left: true,
    //     right: true,
    //     bottom: true,
    //     top: true,
    //   },

    //   // keep the edges inside the parent
    //   restrictEdges: {
    //     outer: 'parent',
    //     endOnly: true,
    //   },

    //   // minimum size
    //   restrictSize: {
    //     min: {
    //       width: 50,
    //       height: 50,
    //     },
    //   },

    //   inertia: true,
    // }).on('resizemove', DragHandler.resizeListener);

    // this is used later in the resizing and gesture demos
    window.dragMoveListener = DragHandler.dragMoveListener;
  }
}



// WEBPACK FOOTER //
// ./src/DragHandler.js